// extracted by mini-css-extract-plugin
export default {"Container":"ChannelBadge_Container__fyW4f"};